import { render, staticRenderFns } from "./node.vue?vue&type=template&id=5e8c0568&scoped=true&"
import script from "./node.vue?vue&type=script&lang=js&"
export * from "./node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c0568",
  null
  
)

export default component.exports